module.exports = __webpack_public_path__ + "img/logo_delta.76b32e43.jpg";